module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-mobile"
  }, [_c('div', {
    staticClass: "hero-mobile__overlay"
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.path === "/"),
      expression: "$route.path === \"/\""
    }],
    staticClass: "hero-mobile__home"
  }, [_c('video', {
    directives: [{
      name: "load-directive",
      rawName: "v-load-directive"
    }],
    staticClass: "hero-mobile__video",
    attrs: {
      "loop": "loop",
      "muted": "muted",
      "autoplay": "autoplay"
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    staticClass: "hero-mobile__source",
    attrs: {
      "src": _vm.props.acf.hero_video,
      "type": "video/mp4",
      "poster": _vm.props.acf.poster
    }
  }), _vm._v("Your browser does not support video.")]), _c('div', {
    staticClass: "hero-mobile__buttons"
  }, [(_vm.props.acf.virtual_services_button.label && _vm.props.acf.virtual_services_button.href) ? _c('a', {
    staticClass: "hero-mobile__button",
    attrs: {
      "href": _vm.props.acf.virtual_services_button.href
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.virtual_services_button.label)
    }
  }) : _vm._e()])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.path === "/about-us"),
      expression: "$route.path === \"/about-us\""
    }],
    staticClass: "hero-mobile__about-us",
    style: ({
      backgroundImage: 'url(static/about-mobile-bg.jpg)'
    })
  }, [_c('div', {
    staticClass: "hero-mobile__title"
  }, [_vm._v(_vm._s(_vm.$route.name))])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.path === "/new-patients"),
      expression: "$route.path === \"/new-patients\""
    }],
    staticClass: "hero-mobile__new-pats",
    style: ({
      backgroundImage: 'url(static/new-pats.jpg)'
    })
  }, [_c('div', {
    staticClass: "hero-mobile__title"
  }, [_vm._v(_vm._s(_vm.$route.name))])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.path === "/treatments"),
      expression: "$route.path === \"/treatments\""
    }],
    staticClass: "hero-mobile__treatments",
    style: ({
      backgroundImage: 'url(static/treatments.jpg)'
    })
  }, [_c('div', {
    staticClass: "hero-mobile__title"
  }, [_vm._v(_vm._s(_vm.$route.name))])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.path === "/mattiacio-difference"),
      expression: "$route.path === \"/mattiacio-difference\""
    }],
    staticClass: "hero-mobile__matt-diff",
    style: ({
      backgroundImage: 'url(static/matt-diff-bg1.jpg)'
    })
  }, [_c('div', {
    staticClass: "hero-mobile__title"
  }, [_vm._v(_vm._s(_vm.$route.name))])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.path === "/invisalign"),
      expression: "$route.path === \"/invisalign\""
    }],
    staticClass: "hero-mobile__invisalign",
    style: ({
      backgroundImage: 'url(static/invisalign.jpg)'
    })
  }, [_c('div', {
    staticClass: "hero-mobile__title"
  }, [_vm._v(_vm._s(_vm.$route.name))])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.path === "/contact-us"),
      expression: "$route.path === \"/contact-us\""
    }],
    staticClass: "hero-mobile__contact",
    style: ({
      backgroundImage: 'url(static/contact.jpg)'
    })
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.path.includes("/covid-19-updates")),
      expression: "$route.path.includes(\"/covid-19-updates\")"
    }],
    staticClass: "hero-mobile__covid",
    style: ({
      backgroundImage: 'url(static/covid-19-updates.jpg)'
    })
  }, [_c('div', {
    staticClass: "hero-mobile__title"
  }, [_vm._v(_vm._s(_vm.$route.name))])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.path.includes("/virtual-services")),
      expression: "$route.path.includes(\"/virtual-services\")"
    }],
    staticClass: "hero-mobile__virtual-services",
    style: ({
      backgroundImage: 'url(static/virtual-services.jpg)'
    })
  }, [_c('div', {
    staticClass: "hero-mobile__title"
  }, [_vm._v(_vm._s(_vm.$route.name))])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.path.includes("/videos")),
      expression: "$route.path.includes(\"/videos\")"
    }],
    staticClass: "hero-mobile__videos",
    style: ({
      backgroundImage: 'url(static/mattiacio-videos-poster.png)'
    })
  }, [_c('div', {
    staticClass: "hero-mobile__title"
  }, [_vm._v(_vm._s(_vm.$route.name))])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.path.includes("/virtual-consultation")),
      expression: "$route.path.includes(\"/virtual-consultation\")"
    }],
    staticClass: "hero-mobile__virtual-consultation",
    style: ({
      backgroundImage: 'url(static/new-pats.jpg)'
    })
  }, [_c('div', {
    staticClass: "hero-mobile__title"
  }, [_vm._v(_vm._s(_vm.$route.name))])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.path.includes("/7-and-up")),
      expression: "$route.path.includes(\"/7-and-up\")"
    }],
    staticClass: "hero-mobile__7-and-up",
    style: ({
      backgroundImage: 'url(static/new-pats.jpg)'
    })
  }, [_c('div', {
    staticClass: "hero-mobile__title"
  }, [_vm._v(_vm._s(_vm.$route.name) + "    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-023c7449","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/hero-mobile/hero-mobile.pug
// module id = 664
// module chunks = 1